module.exports = __webpack_public_path__ + "img/lifesupport.0cdcf6bc.svg";